'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSelectedDashboardFeis = exports.getGroupFeesForFeis = exports.getAccountsForFeis = exports.getPersonsForFeis = exports.getFeis = exports.feisAdjudicatorsAreLoading = exports.getFlagsForPerson = undefined;

var _immutable = require('immutable');

var getFlagsForPerson = exports.getFlagsForPerson = function getFlagsForPerson(state, fid, pid) {
  return state.getIn(['feiseanna', 'persons', fid, pid]) || (0, _immutable.Map)();
};

var feisAdjudicatorsAreLoading = exports.feisAdjudicatorsAreLoading = function feisAdjudicatorsAreLoading(state, fid) {
  return !state.getIn(['feiseanna', 'adjudicators', fid]) || state.getIn(['feiseanna', 'adjudicators', fid, 'loading']);
};

var getFeis = exports.getFeis = function getFeis(state, fid) {
  return state.getIn(['feiseanna', 'one', fid]) || (0, _immutable.Map)();
};

var getPersonsForFeis = exports.getPersonsForFeis = function getPersonsForFeis(state, fid) {
  return state.getIn(['feiseanna', 'persons', fid]) || (0, _immutable.Map)();
};

var getAccountsForFeis = exports.getAccountsForFeis = function getAccountsForFeis(state, fid) {
  return state.getIn(['feiseanna', 'carts', fid, 'accounts']) || (0, _immutable.Map)();
};

var getGroupFeesForFeis = exports.getGroupFeesForFeis = function getGroupFeesForFeis(state, fid) {
  return state.getIn(['feiseanna', 'groupFees', fid]) || (0, _immutable.List)();
};

var getSelectedDashboardFeis = exports.getSelectedDashboardFeis = function getSelectedDashboardFeis(state) {
  return state.getIn(['feiseanna', 'one', 'selectedFeis']);
};


//////////////////
// WEBPACK FOOTER
// /Users/vidhigupta/isomorphic/lib/redux/actions/feiseanna/paths.js
// module id = 26
// module chunks = 0